import React from 'react';
import PropTypes from 'prop-types';
import { cssTransition } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Fade = cssTransition({ enter: 'fadeIn', exit: 'fadeOut' });

export const CloseButton = ({ closeToast }) => (
  <button
    type="button"
    className="p-2 border-0 bg-transparent"
    style={{ color: 'inherit' }}
    aria-label="Close notification"
    onClick={closeToast}
  >
    <FontAwesomeIcon icon="times" className="fs--2" />
  </button>
);

CloseButton.propTypes = { closeToast: PropTypes.func };
